module.exports = __webpack_public_path__ + "img/cookies2x.3cb46c1e.png";